import { Event, EventHint } from '@sentry/vue'

import { addFederatedInfo } from './federatedApps'
import { addUnhandledRejectionTrace } from './unhandledRejections'
import { conditionalProfiling } from './conditionalProfiling'
import { filterExemptedErrors } from './ignoredExceptions'
import { filterFirebaseError } from './firebase'
import { filterMacOsUnwantedExceptions } from './macOsErrors'

export const filterEvents = (event: Event, hint: EventHint): Event | null => {
  if (event.type === 'profile') {
    return conditionalProfiling(event)
  }

  /** Unhandled Rejections */
  const unhandledRejectionEvent = addUnhandledRejectionTrace(event, hint)
  if (unhandledRejectionEvent) {
    return addFederatedInfo(unhandledRejectionEvent)
  }

  /** Custom Filters  */
  const isFilteredOut = [
    filterExemptedErrors(event, hint),
   // filterFirebaseError(event, hint),
    filterMacOsUnwantedExceptions(hint),
  ].some(Boolean)

  if (isFilteredOut) {
    return null
  }

  return addFederatedInfo(event)
}
